export const checkValidDate = date => {
  if (date.indexOf('/') < 0 && date.length > 8) {
    return false;
  }

  if (date.indexOf('/') > 0) {
    date =  date.replace(/\//g, '').replace(/\s/g, '').trim();
  }

  if (date.length < 8) {
    return false;
  }

  const month = parseInt(date.substr(0, 2));
  const day = parseInt(date.substr(2, 2));
  const year = parseInt(date.substr(4, 4));

  if (day < 1 || day > 31) {
    return false;
  }

  if (month < 1 || month > 12) {
    return false;
  }

  if (year < 1900 || year > new Date().getFullYear()) {
    return false;
  }

  if (month === 4 || month === 6 || month === 9 || month === 11) {
    if (day > 30) {
      return false;
    }
  }

  if (month === 2 && year%4 === 0) {
    if (day > 29) {
      return false;
    }
  }

  if (month === 2 && year%4 !== 0) {
    if (day > 29) {
      return false;
    }
  }

  return true;
};

export const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}
